import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import LoadingIndicator from "components/shared/LoadingIndicator";
import { MANAGE_NOTIFICATION_EMAIL_TEMPLATE_EDIT, MANAGE_NOTIFICATION_EMAIL_TEMPLATE_LIST } from "config/paths";
import { useGetTemplateListQuery } from "store/services/notification";
import { TEMPLATES_TITLE } from "config/constants";
import { EditIcon } from "Assets/icons";

const ManageNotificationTemplate = () => {

    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(50);
    const [filter, setFilter] = useState({ type: "email", search: "", status: "", sort: { column: "id", direction: "desc" } });
    const [emailTemplateData, setEmailTemplateData] = useState({});
    const { data, isLoading } = useGetTemplateListQuery({ page: currentPage, limit: pageSize, ...filter });

    useEffect(() => {
        if (data?.records?.length) {
            const emailObj = {};

            for (let i of data?.records) {

                const title = TEMPLATES_TITLE[i.notification_type];
                if (emailObj[title]) emailObj[title].push(i)
                else emailObj[title] = [i]
            };

            setEmailTemplateData(emailObj);
        };
    }, [data]);
console.log("emailTemplateData",emailTemplateData)
    return (
        <>
            <section className="ManageDiscriplines position-relative py-4">
                <Container fluid={true}>
                    <Row>
                        <Col lg="12" className="my-2">
                            <div className="TableFilter d-flex align-items-center justify-content-between gap-10 flex-wrap">
                                <div className="left">
                                    <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center gap-10 flex-wrap">
                                        <li className="">
                                            <h6 className="m-0 fw-bold themeBlue">
                                                Email Notifications
                                            </h6>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </Col>
                        {
                            isLoading ? <LoadingIndicator /> : (
                                <Col lg="12" className="my-2">
                                    <Row className="justify-content-between mt-2">
                                        {
                                            Object.keys(emailTemplateData)?.map((item, index) => {
                                                return (
                                                    <Col key={index} md="6" className="my-3">
                                                        <h6 className="m-0 fw-bold themeBlue mb-3 text-capitalize">{item}</h6>
                                                        <ul className="list-unstyled ps-0 mb-0">
                                                            {
                                                                emailTemplateData[item]?.map((itm, ind) => {

                                                                    return (
                                                                        <li key={ind} className="py-2 d-flex align-items-start gap-10  border-bottom my-3">
                                                                            <h6
                                                                                style={{ fontSize: 12 }}
                                                                                className="w-50 themeBlue fw-bold text-capitalize"
                                                                            >
                                                                                {itm?.subject || "--"}
                                                                            </h6>
                                                                            <p style={{ width: "250px", textOverflow: "ellipsis", overflow: "hidden", textWrap: "nowrap" }} className="m-0 forteen text-muted w-50">{itm?.template_desc || "--"}</p>
                                                                            <EditIcon
                                                                                style={{ cursor: "pointer" }}
                                                                                onClick={() => navigate(MANAGE_NOTIFICATION_EMAIL_TEMPLATE_EDIT.replace(":id", itm?.id))}
                                                                            />
                                                                        </li>
                                                                    )
                                                                })
                                                            }
                                                        </ul>
                                                    </Col>
                                                )
                                            })
                                        }
                                    </Row>
                                </Col>
                            )
                        }
                    </Row>
                </Container>
            </section>
        </>
    );
};

export default ManageNotificationTemplate;
